export default __webpack_public_path__ + "static/media/logo.453c6e3b.svg";